import { Paper, type SxProps, type Theme } from "@mui/material";
import { type ReactNode } from "react";

interface Props {
  children: ReactNode;
  padding?: number | string;
  sx?: SxProps<Theme>;
}

export const PaperCard = ({ children, padding = 4, sx }: Props) => {
  return (
    <Paper
      sx={{
        p: padding,
        border: (theme) => `1px solid ${theme.palette.divider}`,
        ...sx,
      }}
    >
      {children}
    </Paper>
  );
};
